<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedLevels"
      multi-select
      class="tw-w-full"
      :label="meta.filter.quickFilter ? '' : $t('Seniority')"
      :list="levels"
      :max-labels-visible="meta.filter.quickFilter ? 1 : 10"
      :placeholder="$t('All experience levels')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { ExpectedExperienceLevel } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedLevels: ModelRef<string[]> = defineModel({
  default: () => [],
})

const levelLabels: Record<string, string> = {
  [ExpectedExperienceLevel.Student]: $t('Student'),
  [ExpectedExperienceLevel.Junior]: $t('Junior'),
  [ExpectedExperienceLevel.MidLevel]: $t('Mid-level'),
  [ExpectedExperienceLevel.Senior]: $t('Senior'),
  [ExpectedExperienceLevel.Expert]: $t('Expert'),
}

const orderedLevels = [
  ExpectedExperienceLevel.Student,
  ExpectedExperienceLevel.Junior,
  ExpectedExperienceLevel.MidLevel,
  ExpectedExperienceLevel.Senior,
  ExpectedExperienceLevel.Expert,
]

const levels = computed(() =>
  orderedLevels.map((value) => ({
    label: levelLabels[value] ?? value,
    value,
  })),
)
</script>
